import * as yup from 'yup';

const roomSchema = yup
  .object({
    isChecked: yup.boolean().required(),
    roomId: yup.number().required(),
    totalSeats: yup.number().required(),
    seatLimit: yup
      .number()
      .typeError('Value is required')
      .min(1, 'Value is required')
      .required('Value is required'),
  })
  .test('seatLimit', 'Seat limit cannot exceed total seats', function (room) {
    if (!room) return true;
    return room.seatLimit <= room.totalSeats;
  });

const sessionTypeFilterSchema = yup.object({
  public: yup.boolean().required(),
  closed: yup.boolean().required(),
});

export const schema = yup.object({
  sessionTypeFilter: sessionTypeFilterSchema.required(),

  agentId: yup
    .number()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .nullable()
    .default(null)
    .when('sessionTypeFilter.closed', {
      is: true,
      then: (s) => s.nullable(),
      otherwise: (s) => s.oneOf([null]).nullable(),
    }),

  rooms: yup
    .array()
    .of(roomSchema)
    .test('atLeastOneChecked', 'Select at least one room', function (rooms) {
      const len = rooms?.filter((x) => x.isChecked === true).length ?? 0;
      return len > 0;
    })
    .required(),
});

export type AddRoomBookingFormValues = yup.InferType<typeof schema>;
